import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  pageHeaderInfo: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    fontSize: 16
  },
  pageHeaderInfoName: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  pageHeaderInfoDeadline: {
    fontSize: 14,
    color: theme.palette.primary.dark
  }
}));
